"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _symbols = _interopRequireDefault(require("./symbols"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var displayName = 'Graphic';
var Graphic = (0, _styledComponents.default)(function (props) {
  var _Symbol = _symbols.default[props.symbol];
  var width = props.width,
      height = props.height,
      rest = (0, _tslib.__rest)(props, ["width", "height"]);
  return React.createElement(_Symbol, (0, _tslib.__assign)({}, rest));
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  display: inline-block;\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  ", "\n  ", "\n"])), _styledSystem.width, _styledSystem.height);
Graphic.displayName = displayName;
var _default = Graphic;
exports.default = _default;
var templateObject_1;